import { useState } from 'react';
import { Box, Flex } from 'reflexbox';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import { Button } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import Paragraph, { ParagraphSmall } from 'packages/kakapo-ui-kit/components/common/Paragraph';
import Modal, {
	ModalBackground,
	ModalContent,
} from 'packages/kakapo-ui-kit/components/modals/Modal';
import ModalHeader from 'packages/kakapo-ui-kit/components/modals/ModalHeader';
import ModalFooter from 'packages/kakapo-ui-kit/components/modals/ModalFooter';

function SignatureConfirm(props: { onCancel: () => void; onConfirm: () => void }) {
	const { t } = useTranslation();

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader>{t('evaluation.submission.confirm.modal.title')}</ModalHeader>
				<ModalContent>
					<Paragraph>{t('evaluation.submission.confirm.modal.description')}</Paragraph>
				</ModalContent>
				<ModalFooter>
					<Flex px={3} alignItems="center" justifyContent="flex-end">
						<Box mr={2}>
							<Button
								title={t('evaluation.submission.confirm.modal.cancel')}
								onClick={() => props.onCancel()}
							/>
						</Box>
						<Button
							title={t('evaluation.submission.confirm.modal.confirm')}
							onClick={() => props.onConfirm()}
						/>
					</Flex>
				</ModalFooter>
			</Modal>
		</ModalBackground>
	);
}

export default function Signature(props: {
	name: string;
	item: graphql.EvaluationSignatureItem;
	readonly?: boolean;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const [field, , { setValue }] = useField<boolean>(props.name + '.signature');
	const value = field.value ?? false;

	const [confirm, setConfirm] = useState(false);

	return (
		<>
			<ParagraphSmall color="slateBlue" style={{ maxWidth: 600 }}>
				{localize(props.item.title ?? []).text}
			</ParagraphSmall>
			{value ? null : (
				<>
					{confirm && (
						<SignatureConfirm
							onCancel={() => setConfirm(false)}
							onConfirm={() => {
								setValue(true);
								setConfirm(false);
							}}
						/>
					)}
					<Box mt={3}>
						<Button onClick={() => setConfirm(true)}>
							{t('evaluation.submission.confirm.button')}
						</Button>
					</Box>
				</>
			)}
		</>
	);
}
